import React from 'react'
import { useTranslation } from 'react-i18next'
import lmsLogo from '../../../assets/images/moodlenew.png'
import '../integration.scss'
import { INTEGRATION_TYPE } from '../../../config/index'
import { useHistory } from 'react-router'
import { Image } from 'react-bootstrap'

const MoodleIntegration = (props: any) => {
  const { t } = useTranslation('translation')
  const history = useHistory()

  const clickIntegration = () => {
    history.push(INTEGRATION_TYPE.replace(':type', 'moodle'))
  }

  return (
    <>
      <div
        role="button"
        className="integration-item"
        onClick={(e: any) => {
          e.stopPropagation()
          clickIntegration()
        }}
      >
        <div className="container-fluid d-inline-flex justify-content-between align-items-center p-0">
          <Image src={lmsLogo} />
        </div>
        <div className="integrationBox-heading">
          <h4>Moodle</h4>
        </div>
        <div>
          {t(
            'Moodle provides a single robust, secure and integrated system to create personalised learning environments',
          )}
        </div>
        <div className="configure-btn">
          <button
            className="btn btn-primary tw-ml-auto"
            onClick={() => clickIntegration()}
          >
            {t('Configure')}
          </button>
        </div>
      </div>
    </>
  )
}

export default MoodleIntegration
